import { property } from './LitElement/index.js';
import { initializeTranslator, use } from '../scripts/translator.js';

/**
 * Internationalization mixin for lit-element based components.
 */
const i18n = languageDefinitions => TargetClass =>
  class extends TargetClass {
    /**
     * @type {string}
     */
    @property({ type: String })
    accessor locale = 'sk-SK';

    /**
     * Initialize translator on first update of widget.
     */
    firstUpdated(changedProperties) {
      if (super.firstUpdated) {
        super.firstUpdated(changedProperties);
      }

      initializeTranslator(languageDefinitions);
    }

    /**
     * Change locale in case of its change.
     */
    updated(changedProperties) {
      if (super.updated) {
        super.updated(changedProperties);
      }

      if (changedProperties.has('locale')) {
        use(this.locale);
      }
    }
  };

export default i18n;
